import intl from 'react-intl-universal';
import React from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd';
import { default as Button } from '@/components/CssBtn';

const CssModal: React.FC<ModalProps> = (props) => {
    const { children, onCancel, onOk, ...restProps } = props;
    const currentFooter = () => {
        if (restProps.footer) return restProps.footer;
        const footerArr = [];
        if (onCancel) {
            footerArr.push(
                <Button
                    key="cancel"
                    type="default"
                    onClick={onCancel}
                >
                    {intl.get('取消')}
                </Button>,
            );
        }
        if (onOk) {
            footerArr.push(
                <Button
                    key="ok"
                    type="primary"
                    onClick={onOk}
                >
                    {intl.get('确定')}
                </Button>,
            );
        }
        return footerArr.length > 0 ? footerArr : null;
    };
    return (
        <Modal
            footer={currentFooter}
            {...restProps}
            onCancel={onCancel}
            onOk={onOk}
        >
            {children}
        </Modal>
    );
};

export default CssModal;
